import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AVAILABLE_LOANS_FEATURE_KEY, ACTIVE_LOANS_FEATURE_KEY, LOAN_PURPOSES_FEATURE_KEY } from './reducers';

/**
 * Available loans
 */
export const selectAvailableLoansState = createFeatureSelector<any>(AVAILABLE_LOANS_FEATURE_KEY);
export const selectAvailableLoans = createSelector(
  selectAvailableLoansState,
  (state: any) => state?.availableLoans
);

/**
 * Active loans
 */
export const selectActiveLoansState = createFeatureSelector<any>(ACTIVE_LOANS_FEATURE_KEY);
export const selectActiveLoans = createSelector(
  selectActiveLoansState,
  (state: any) => state?.activeLoans
);

/**
 * Loan purposes
 */
export const selectLoanPurposesState = createFeatureSelector<any>(LOAN_PURPOSES_FEATURE_KEY);

export const selectHomeLoanPurposes = createSelector(
  selectLoanPurposesState,
  (state: any) => state?.homeLoanPurposes || []
);

export const selectCarLoanPurposes = createSelector(
  selectLoanPurposesState,
  (state: any) => state?.carLoanPurposes || []
);

export const selectCreditCardPurposes = createSelector(
  selectLoanPurposesState,
  (state: any) => state?.creditCardPurposes || []
);
